import { render, staticRenderFns } from "./SimpleSidebar.vue?vue&type=template&id=a2b537fa&scoped=true"
import script from "./SimpleSidebar.vue?vue&type=script&lang=js"
export * from "./SimpleSidebar.vue?vue&type=script&lang=js"
import style0 from "./SimpleSidebar.vue?vue&type=style&index=0&id=a2b537fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2b537fa",
  null
  
)

export default component.exports